<template>
  <ion-header class="app-width">
    <ion-toolbar>
      <ion-title>Course Options</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="app-width">
      <article v-if="this.selectedCourses.length > 0" class="article-box-small blurb blurb-boxed blurb-info p-4 mb-2">
        <div class="blurb-title h4 text-center">Selected Courses</div>
        <div class="blurb-subtitle h6 text-center">Please select 3 of your preferred courses in their preferred order</div>
        <div class="blurb-text">
<!--          <ion-list>-->
<!--            <ion-item v-for="c in this.selectedCourses" v-bind:key="c.id">-->
<!--              <ion-chip :color="'success'">-->
<!--                {{ c.order_no }}-->
<!--              </ion-chip>-->
<!--              {{ c.info.uni_name }}, {{ c.info.course_name }}-->
<!--              <ion-icon slot="end" :icon="trashOutline" v-on:click="deleteCourse(c)"></ion-icon>-->
<!--            </ion-item>-->
<!--          </ion-list>-->
          <ion-accordion-group>
            <ion-accordion v-for="c in this.selectedCourses" v-bind:key="c.id" :value="c.id">
              <ion-item slot="header" style="width: 90%">
                <ion-chip :color="'success'">
                  {{ c.order_no }}
                </ion-chip>
                {{ c.info.uni_name }}, {{ c.info.course_name }}
                <ion-icon slot="end" :icon="trashOutline" v-on:click="deleteCourse(c)"></ion-icon>
              </ion-item>
              <ion-list slot="content">
                <div lines="none" style="margin-left: 3em">
                  <p style="margin-top: 1px" v-for="d of (c.details || '').split('\n')" v-bind:key="d">
                    {{ d }}
                  </p>
                </div>
                <ion-item>
                  <ion-button color="primary" v-on:click="selectCourse(u, c)">SELECT</ion-button>
                </ion-item>
              </ion-list>
            </ion-accordion>
          </ion-accordion-group>
        </div>
      </article>
      <article v-if="!loading && selectedCourses?.length < 3 && (!universities || universities.length <= 0)" class="article-box-small blurb blurb-boxed blurb-warning p-4 mb-2">
        <div class="blurb-title h4 text-center">No Course Options</div>
        <div class="blurb-subtitle h6 text-center">Unfortunately we could not find any available university course options for you. </div>
        <div class="blurb-subtitle h6 text-center">Please check your details and try again on a later stage or please get in touch with us for further assistance</div>
      </article>
      <article v-if="!loading && selectedCourses?.length === 3 " class="article-box-small blurb blurb-boxed blurb-light p-4 pb-0">
        <div class="blurb-title h6 text-center">Thank you for selecting your preferred courses</div>
        <div class="blurb-subtitle h6 text-center">Our expert team will be in touch with you shortly</div>
        <div class="blurb-subtitle h6 text-center mb-1">In the mean time, please upload your documents </div>

        <div class="text-center border-1" >
          <router-link to="/documents/" class="btn btn-lg btn-round text-center">
<!--          <a class="btn btn-lg btn-round text-center" href="enrol/index.html">-->
            <span class="btn-icon mdi-file-pdf novi-icon"></span><span>UPLOAD DOCUMENTS NOW</span>
<!--            </a>-->
          </router-link>
        </div>

      </article>
      <article v-if="(universities && universities.length > 0)" class="article-box-small blurb blurb-boxed p-1 mb-2">
        <div class="blurb-title h4 text-center">Course Options</div>
        <div class="blurb-subtitle h6 text-center">Following is a list of course options matching your qualifications. Please select 3 of your preferred courses in their preferred order</div>
        <hr class="blurb-divider divider divider-sm">
        <div class="blurb-text">
          <ion-item v-for="u in universities" v-bind:key="u.code">
            <ion-grid>
              <ion-row>
                <ion-col size="12" size-md="2">
                  <img style="max-width: 7em" v-if="u.logo && u.logo.url" :src="'/assets/universities/logos/'+u.logo.url">
                </ion-col>
                <ion-col size="12" size-md="9">
                  <h5>{{ u.name }}</h5>
                  <ion-accordion-group>
                    <ion-accordion v-for="c in u.courses" v-bind:key="c.id" :value="c.id">
                      <ion-item slot="header" style="width: 90%">
                        <h6>{{ c.name }}, {{ c.city }}</h6>
                      </ion-item>
                      <ion-list slot="content">
                        <div lines="none" style="margin-left: 3em">
                          <p style="margin-top: 1px" v-for="d of (c.details || '').split('\n')" v-bind:key="d">
                            {{ d }}
                          </p>
                        </div>
                        <ion-item>
                          <ion-button color="primary" v-on:click="selectCourse(u, c)">SELECT</ion-button>
                        </ion-item>
                      </ion-list>
                    </ion-accordion>
                  </ion-accordion-group>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        </div>
      </article>
    </div>
  </ion-content>

  <!--    <ion-footer>-->
  <!--      <ion-toolbar>-->
  <!--        <ion-button slot="start" v-on:click="back()">-->
  <!--          <ion-icon :icon="chevronBackOutline"></ion-icon>-->
  <!--          Back-->
  <!--        </ion-button>-->
  <!--        <ion-button slot="end" v-on:click="proceed()">-->
  <!--          Next-->
  <!--          <ion-icon :icon="chevronForwardOutline"></ion-icon>-->
  <!--        </ion-button>-->
  <!--      </ion-toolbar>-->
  <!--    </ion-footer>-->
</template>

<script>
import {
  popoverController,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonItem,
  IonIcon,
  IonChip,
  IonList,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonAccordion,
  IonAccordionGroup,
} from '@ionic/vue';
import {
  chevronForwardOutline,
  chevronBackOutline,
  trashOutline
} from 'ionicons/icons';

import eoppService from "@/mixins/EoppService";
import actRouter from "@/account/ActRouter";
import CourseDetail from "@/enrol/CourseDetail";

export default {
  name: 'CourseOptions',
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonItem,
    IonIcon,
    IonChip,
    IonList,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonAccordion,
    IonAccordionGroup
  },
  mixins: [eoppService],
  data() {
    return {
      chevronForwardOutline,
      chevronBackOutline,
      trashOutline,
      mirror: true,
      universities: [],
      selectedCourses: [],
      loading: null
    };
  },
  mounted() {
    if (this.lead) {
      this.getSelectedLeadCourses();
    } else {
      this.getAccountLead().then(res => {
        console.log(res.data);
        this.$store.commit('leadInfo', res.data);
        this.getSelectedLeadCourses();
        this.loadCourses();

      })
    }
  },
  methods: {
    back: function () {
      this.setAnswer();
      actRouter.push({path: '/language'})
    },
    proceed: function () {
      // this.setAnswer();
      // this.loadCourses();
      // actRouter.push({ path: '/quiz' })
    },
    selectCourse: function (university, course) {
      console.log(university, course);
      if (this.selectedCourses.length > 2) {
        this.presentAlert('Warning', '', 'You can only select 3 course options')
      } else {
        let c1 = this.selectedCourses.find(o => o.ref === course.id);

        if (!c1) {
          let c = {
            info: {
              uni_id: university.id,
              uni_code: university.code,
              uni_name: university.name,
              uni_url: university.url,
              country_code: university.country_code,
              city: course.city,
              course_id: course.id,
              course_code: course.code,
              course_name: course.name,
              course_location: course.location_name,
              course_details: course.details,
            },
            lead_id: this.lead.id,
            type: "course",
            ref: course.id,
            order_no: this.selectedCourses.length + 1,
            timeid: Date.now(),
            title: course.name + ',' + university.name
          }

          this.saveSelectedCourse(c);
        }
      }
    },
    getSelectedLeadCourses: function () {
      if (this.lead) {
        this.getCRMData(`/crm/account/lead/items?type=course`).then(res => {
          this.selectedCourses = (res.data || []).sort((a, b) => a.order_no - b.order_no);

          if ( this.selectedCourses.length < 3 ){
            this.loadCourses();
          }
        });
      }
    },
    deleteCourse: function (course) {
      if (this.lead) {
        this.deleteCRMData(`/crm/account/lead/items`, {id: course.id}).then(res => {
          let cid = this.selectedCourses.indexOf(course);
          this.selectedCourses.splice(cid, 1);
          console.log(res);
          let idx = 1;
          this.selectedCourses.forEach(c => c.order_no = idx++);
          this.postCRMData('/crm/account/lead/items', this.selectedCourses).then(res2 => {
            console.log(res2.data);
            this.selectedCourses = res2.data;
          });

          this.loadCourses();
        });
      }
    },
    saveSelectedCourse: function (item) {
      if (item) {
        this.postCRMData('/crm/account/lead/items', [item]).then(res => {
          console.log(res.data);
          this.selectedCourses.push(...res.data);

          if ( this.selectedCourses?.length > 2) {
            this.universities = [];
          }
        });
      }
    },
    loadCourses: function () {
      this.showLoading();
      if (this.lead.cf && this.lead.cf.pref_program) {
        this.postData('/enrol/courses', this.lead).then(res => {
          console.log(res.data.length);
          this.universities = res.data;
          this.showLoading(5000);
        });
      }
    },
    saveLead: function () {
      if (this.lead) {
        this.updateCrmRecord([this.lead], null).then(res => {
          console.log(res);
        });
      }
    },
    async presentCourseDetail(course) {
      const popover = await popoverController.create({
        component: CourseDetail,
        cssClass: 'course-detail-popupxxxx',
        componentProps: {
          course: course
        },
        // event: ev,
        translucent: true
      });
      await popover.present();

      const {role} = await popover.onDidDismiss();
      console.log('onDidDismiss resolved with role', role);
    }
  }
}
</script>
<style>

@media only screen and (max-width: 1023px) {
  .app-window2 {
    max-width: 100%;
    min-height: 100%;
  }
}

</style>
